import { useEffect } from 'react';
// eslint-disable-next-line react-hooks/exhaustive-deps
export default function useMountEffect(fun) {
	useEffect(fun);
}
